import { IRoute } from "src/pages/Router/routes";

import RecordWastePage from "./RecordWastePage";

export const CustomerWasteManagement: IRoute[] = [
  {
    exact: true,
    path: "/waste/report-wastage",
    pageComponent: RecordWastePage,
    title: "Record Waste",
    menuType: "MAIN",
    roles: [ "customer" ],
    permissions: [ "create-waste" ],
    hidden: true
  }
];

export default CustomerWasteManagement;
